import { AnyAction } from "redux";
import { CREATE_VENDOR_APPOINTMENT_FAILURE, CREATE_VENDOR_APPOINTMENT_REQUEST, CREATE_VENDOR_APPOINTMENT_SUCCESS, GET_VENDOR_APPOINTMENT_FAILURE, GET_VENDOR_APPOINTMENT_REQUEST, GET_VENDOR_APPOINTMENT_SUCCESS } from "../constants/vendor.constants";

const initialState = {
    loading: false,
    data: [],
    error: '',
    count: 0,
    createdVendor: {
        loading: false,
        data: [],
        error: '',
    },

};

export const vendorAppintmentListReducer = (state = initialState, action: AnyAction) => {
    switch (action.type) {
        case GET_VENDOR_APPOINTMENT_REQUEST:
            return {
                ...state,
                loading: true,
            };

        case GET_VENDOR_APPOINTMENT_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                errorMsg: '',
            };
        case GET_VENDOR_APPOINTMENT_FAILURE:
            return {
                ...state,
                loading: false,
                data: [],
                error: action.payload,
            };
        case CREATE_VENDOR_APPOINTMENT_REQUEST:
            return {
                ...state,
                createdVendor: {
                    ...state.createdVendor,
                    loading: true,
                    error: '',
                    data: [],
                },
            };
        case CREATE_VENDOR_APPOINTMENT_SUCCESS:
            return {
                ...state,
                createdVendor: {
                    ...state.createdVendor,
                    loading: false,
                    data: action.payload,
                },
            };
        case CREATE_VENDOR_APPOINTMENT_FAILURE:
            return {
                ...state,
                createdVendor: {
                    ...state.createdVendor,
                    loading: false,
                    data: [],
                    error: action.payload,
                },
            };
        default:
            return state;
    }
}